import Vue from "vue";
import VuetifyMoney from "@/components/inputs/money/index.js";
Vue.use(VuetifyMoney);
export default VuetifyMoney;